<template>
  <div class="flex flex-col gap-1">
    <slot />
  </div>
</template>
